import { TOKEN_PATH } from "src/config";
import { useAxios } from "src/networking/axios";
import { AxiosGateCallbacks, AxiosGateRequest, GetIdToken } from "src/types";
import {
  AUTHFLOW,
  CLIENT_ID,
  PASSWORD,
  USER_POOL_ID,
  USERNAME,
} from "src/config";

export const useGetIdToken = <
  T extends GetIdToken["request"],
  D extends GetIdToken["response"]
>() => {
  const hook = useAxios<T, D>("getIdToken");

  return {
    ...hook,
    crossGate: (
      request: AxiosGateRequest<T>,
      callbacks: AxiosGateCallbacks<D>
    ) => {
      return hook.crossGate(
        {
          method: "post",
          baseURL: TOKEN_PATH,
          ...request,
        },
        callbacks
      );
    },
  };
};

export const GET_TOKEN_HEADER = {
  "Content-Type": "application/x-amz-json-1.1",
  "X-Amz-Target": "AWSCognitoIdentityProviderService.InitiateAuth",
};

export const GET_TOKEN_BODY = {
  AuthFlow: AUTHFLOW,
  AuthParameters: {
    USERNAME: USERNAME,
    PASSWORD: PASSWORD,
  },
  ClientId: CLIENT_ID,
  UserPoolId: USER_POOL_ID,
};
